/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
    Card,
    Container,
    Row,
    Col,
    UncontrolledTooltip,
} from "reactstrap";

// core components

// index page sections
import {RiCheckFill, RiCloseFill, RiTeamLine, RiUser3Line} from "react-icons/ri";
import {getStats} from "../../components/helpers/StatsHelpers";

class FeaturesMatrix extends React.Component {
    state = {
        songBookCount: null
    };

    constructor(props) {
        super(props);
        getStats.call(this);
    }

    render() {
        return (
            <section className="section section-lg pt-0">
                <Container>
                    <Card className="bg-primary shadow-lg border-0">
                        <div className="p-5">
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        &nbsp;
                                    </h2>
                                    <h3 className="text-white align-content-center">
                                        Features
                                    </h3>
                                </Col>
                                <Col lg="3" className="text-white text-center align-content-center">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        &nbsp;
                                    </h2>
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        <RiUser3Line color='white' size="36"/><br/>Free
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center align-content-center">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        &nbsp;
                                    </h2>
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        <RiUser3Line color='white' size="36"/><br/>Single User
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center align-content-center">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        &nbsp;
                                    </h2>
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        <RiTeamLine color='white' size="36"/><br/>Groups
                                    </h2>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Build from Scripture
                                    </h2>
                                    <p className="text-white" style={{fontSize:"0.75em"}}>Old Testament / New Testament / Apocrypha</p>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Build from multiple song books
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Choose from
                                        {" "}{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Songs").value}{" "}
                                        Songs
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Build from
                                        {" "}{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Themes").value}{" "}
                                        Biblical Themes
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Build from
                                        {" "}{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Lectionaries").value}{" "}
                                        Lectionaries
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Service Planner
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Reorder curated song-flows
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Share curated song-flows
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <span id="tooltip-free-shares" style={{ borderBottom: "1px dotted rgba(255,255,255,0.6)", cursor: "help" }}>
                                        3 shares
                                    </span>
                                    <UncontrolledTooltip delay={0} placement="top" target="tooltip-free-shares" trigger="hover focus">
                                        Share 3 times as a free user — each share can be sent to as many people as you need.
                                    </UncontrolledTooltip>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    Unlimited
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    Unlimited
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Save curated song-flows
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Manage curated song-flows
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCheckFill/>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Multi-user collaboration on song-flows
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    coming soon
                                </Col>
                            </Row>
                            <Row className="">
                                <Col lg="3">
                                    <h2 style={{fontSize: '1rem'}} className="text-white">
                                        Song-flow calendar
                                    </h2>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    <RiCloseFill/>
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    coming soon
                                </Col>
                                <Col lg="3" className="text-white text-center">
                                    coming soon
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Container>
            </section>
        );
    }
}

export default FeaturesMatrix;
